exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq-section[data-v-5a079444] {\n  position: relative;\n  z-index: 11;\n  margin-bottom: 150px;\n}\n.faq-section h2[data-v-5a079444]{\n  letter-spacing: 3px;\n}\n.bullet-list[data-v-5a079444]{\n  margin-bottom: 30px;\n}\n@media (max-width: 1220px) {\n.faq-section[data-v-5a079444] {\n    margin-bottom: 100px;\n}\n}\n", ""]);

// exports
